import { Button } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { getFileExtension, getFilePathForView, isImagePreviewType } from '../../library/constants';

export const PDFViewer = ({ path, type, project_id, item_id }) => {
    const normalizedType = (type || getFileExtension(path))?.toLowerCase()
    const viewUrl = getFilePathForView(path, project_id, item_id)
    const embedStyles = {
        display: 'block',
        border: 0,
        width: '100%',
        height: 'min(82vh, 900px)',
        maxHeight: 'calc(100vh - 180px)',
    }
    const imageStyles = {
        display: 'block',
        width: 'auto',
        height: 'auto',
        maxWidth: 'calc(100vw - 64px)',
        maxHeight: 'calc(100vh - 180px)',
        objectFit: 'contain',
    }

    if (normalizedType == "pdf") {
        return <iframe
            title="File preview"
            src={viewUrl}
            style={embedStyles}>
        </iframe>
    }
    else if (isImagePreviewType(normalizedType)) {
        return (
            <img src={viewUrl} alt="preview" style={imageStyles} />
        )
    }
    else {
        return (
            <object
                data={viewUrl}
                style={embedStyles} >
                <p>Unable to load file.Click on the link below to view the file</p>
                <Button href={viewUrl}>View File</Button>
            </object>

        );
    }

}

PDFViewer.propTypes = {
    path: PropTypes.string,
    type: PropTypes.string,
    project_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    item_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

}
